import { FC, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../../components/card/AttivaCard";
import { Loader } from "../../../../components/loader/SpinnerLogo";
import useFetch from "../../../../hooks/useFetch";
import useHandleErrors from "../../../../hooks/useHandleErrors";
import PageHeader from "../../../../layout/shared/page-header";
import { menuRoutes } from "../../../../router/menu";
import { OrderTypeService } from "../../../../services/order-type/OrderTypeService";
import { OrderType } from "../../../../type/entities/order-type";
import OrderTypeForm from "../OrderTypeForm";

const OrderTypeEdit: FC = () => {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new OrderTypeService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getOrderTypeById(id as string);
        return response.getResponseData() as OrderType;
    }, [id]));

    const pageHeader = {
        title: `Editar Tipo de pedido ( ${data?.name} )`,
        breadcrumb: [
            { name: 'Ventas' },
            { name: 'Gestión de pedidos' },
            { name: 'Tipos de Pedidos', href: menuRoutes.orderTypes.path },
            { name: 'Editar' },
        ],
    };

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        if (values.hoursNumber === '') values.hoursNumber = 0;
        try {
            const response = (await service.editOrderType(values)).getResponseData();
            if (response.success) {
                navigate(-1);
                toast.success("Tipo de pedido editado correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al editar el tipo de pedido");
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos Principales">
                {(data !== null && data !== undefined) && <OrderTypeForm data={data} submit={handleSubmit} isLoading={isLoading} />}
            </AttivaCard>
        </>
    );
}

export default OrderTypeEdit;